module.exports = __webpack_public_path__ + "img/arrow-3.82a2b5eb.svg";